interface Props {
    /** Weekly view counts, oldest first. */
    values: number[];
    width?: number;
    height?: number;
}

/**
 * Tiny inline-SVG bar sparkline for the report table (8 weekly buckets).
 * Recharts is reserved for the drawer chart — a per-row ResponsiveContainer
 * would be far too heavy for 50 rows.
 */
export function Sparkline({ values, width = 72, height = 20 }: Props) {
    const max = Math.max(...values, 1);
    const bw = width / Math.max(values.length, 1);
    return (
        <svg width={width} height={height} aria-hidden className="text-blue-400">
            {values.map((v, i) => {
                const h = v === 0 ? 2 : Math.max(3, Math.round((v / max) * height));
                return (
                    <rect
                        key={i}
                        x={i * bw + 1}
                        y={height - h}
                        width={Math.max(bw - 2, 2)}
                        height={h}
                        rx={1}
                        className={v === 0 ? 'fill-gray-200' : 'fill-current'}
                    />
                );
            })}
        </svg>
    );
}
